<template>
  <div>
    <div class="file-item relative" :style="{ height: height, width: width }">
      <el-image
        v-if="type == 'image'"
        class="image"
        :fit="fit"
        :src="uri"
        @click="handlePreview(uri)"
      />
      <video v-else-if="type == 'video'" class="video" :src="uri" />
      <!-- <div
        v-if="type == 'video'"
        class="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] rounded-full w-5 h-5 flex justify-center items-center bg-[rgba(0,0,0,0.3)]"
      >
        <icon name="el-icon-CaretRight" :size="18" color="#fff" />
      </div> -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 图片地址
    uri: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "240px",
    },
    height: {
      type: String,
      default: "135px",
    },
    // 文件类型
    type: {
      type: String,
      default: "image",
    },
    fit: {
      type: String,
      default: "contain",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handlePreview(file) {
      this.$emit("preview", file);
    },
  },
};
</script>

<style scoped lang="scss">
.file-item {
  box-sizing: border-box;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  // @apply bg-br-extra-light border border-br-extra-light;
  .image,
  .video {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
}
</style>
